import script from "./BrandedLabelElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedLabelElement.vue?vue&type=script&lang=js"
export * from "./BrandedLabelElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedLabelElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/BrandedLabelElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c0da517"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c0da517', __exports__)) {
    api.reload('0c0da517', __exports__)
  }
  
}


export default __exports__